import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { AvailableDevicesActions } from "./available-devices.action-type";
import { Operator } from "src/app/operator/operator.model";

export interface AvailableDevicesState extends EntityState<Operator.AvailableDeviceDocument> {
    availableDevices: Operator.AvailableDeviceDocument[];
    isLoading: boolean;
}

export const adapter: EntityAdapter<Operator.AvailableDeviceDocument> = createEntityAdapter<Operator.AvailableDeviceDocument>({
    selectId: (availableDevicesModel: Operator.AvailableDeviceDocument) => availableDevicesModel._id,
});

export const initialState: AvailableDevicesState = adapter.getInitialState({
    availableDevices: null,
    isLoading: false,
});

export const availableDevicesStateReducer = createReducer(
    initialState,
    on(AvailableDevicesActions.getAvailableDevices, (state) => ({
        ...state,
        isLoading: true,

    })),
    on(AvailableDevicesActions.getAvailableDevicesSuccess, (state, { availableDevices }) =>
        adapter.setAll(availableDevices, {
            ...state,
            availableDevices,
            isLoading: false,
        })
    ),
    on(AvailableDevicesActions.getAvailableDevicesFail, (state) => ({
        ...state,
        isLoading: false,
    })),
    on(AvailableDevicesActions.newAvailableDeviceReceived, (state, { device }) =>
        adapter.upsertOne(device, state)
    ),
    on(AvailableDevicesActions.removeAvailableDevice, (state, { deviceId }) =>
        adapter.removeOne(deviceId, state)
    )
)